import React, { Component } from "react";

class NotFound extends Component {
  render() {
    return <h1>Nie znaleziono strony...</h1>;
  }
}

export default NotFound;
